/**
 * External dependencies
 */
import { Component } from 'react'
import classnames from 'classnames'

import { range } from '~bookwormgb/util/range'

class ProductsPlaceholder extends Component {

	render() {
		const {
			design= 'style-v1',
			columns = 2,
			mdColumns = 2,
			lgColumns = 2,
			xlColumns = 2,
			limit = 4,
			placeholder = 0,
			showImage = true,
			showProductFormat = true,
			showProductTitle = true,
			showProductAuthor = true,
			showProductPrice = true,
			marginBottomCount = 2,
			enableProductWhite = false,
			productCenterAlign = false,
			responsiveLimit = 4,
			responsiveLimitClasses = '',
		} = this.props

		let output = ''

		switch ( design ) {
			case 'style-v1':
				output = (
					<div className={ classnames( [
						'products',
						'bookwormgb-products-placeholder-block',
						'row', 
						'no-gutters',
						'row-cols-2',
						`row-cols-md-${mdColumns}`,
						`row-cols-lg-${lgColumns}`,
						`row-cols-xl-${xlColumns}`,
						`row-cols-wd-${columns}`,
						'border-top',
						'border-left',
					], {} ) }>
						{ range( 1, ( placeholder > 0 ? placeholder : limit ) + 1 ).map( i => {
							return(
								<div className={ classnames( [ 'product bookwormgb-products-placeholder' ], { [ `${ responsiveLimitClasses }` ] : i > responsiveLimit } ) } key={ `product-${i}` }>
									<div className={ classnames( [ 'product__inner overflow-hidden p-3 p-md-4' ], { 'bg-white' : enableProductWhite } ) }>
										<div className={ classnames( [ 'd-block position-relative' ], { 'text-center' : productCenterAlign } ) }>
											{ showImage &&
												<div className="progress bg-light mb-2" style={ { height:'200px' } }></div>
											}
											{ showProductFormat &&
												<div className="badge badge-shadow w-50">
													<div className="progress bg-light"></div>
												</div>
											}
											{ showProductTitle &&
												<div className="badge badge-shadow w-80">
													<div className="progress bg-light"></div>
												</div>
											}
											{ showProductAuthor &&
												<div className={ classnames( [ 'badge badge-shadow w-50 d-block' ], { 'mx-auto' : productCenterAlign } ) }>
													<div className="progress bg-light"></div>
												</div>
											}
											{ showProductPrice &&
												<div className="badge badge-shadow w-50">
													<div className="progress bg-light"></div>
												</div>
											}
										</div>
									</div>
								</div>
							)
						} ) }
					</div>
				)
			break

			case 'style-v2':
			case 'style-v4':
				output = (
					<div className={ classnames( [
						'products',
						'bookwormgb-products-placeholder-block',
						'row', 
						'row-cols-2',
						`row-cols-md-${mdColumns}`,
						`row-cols-lg-${lgColumns}`,
						`row-cols-xl-${xlColumns}`,
						`row-cols-wd-${columns}`,
					], {} ) }>
						{ range( 1, ( placeholder > 0 ? placeholder : limit ) + 1 ).map( i => {
							return(
								<div className={ classnames( [ 'col mb-5 bookwormgb-products-placeholder' ], { [ `${ responsiveLimitClasses }` ] : i > responsiveLimit } ) } key={ `product-${i}` }>
									<div className={ classnames( [ 'border product__space bg-white' ], { 'rounded-md' : design === 'style-v4' } ) }>
										<div className="product__inner overflow-hidden p-3 p-md-4d875">
											<div className="d-block position-relative">
												{ showImage &&
													<div className="progress bg-light mb-2" style={ { height:'200px' } }></div>
												}
												{ showProductFormat &&
													<div className="badge badge-shadow w-50">
														<div className="progress bg-light"></div>
													</div>
												}
												{ showProductTitle &&
													<div className="badge badge-shadow w-80">
														<div className="progress bg-light"></div>
													</div>
												}
												{ showProductAuthor &&
													<div className="badge badge-shadow w-50 d-block">
														<div className="progress bg-light"></div>
													</div>
												}
												{ showProductPrice &&
													<div className="badge badge-shadow w-50">
														<div className="progress bg-light"></div>
													</div>
												}
											</div>
										</div>
									</div>
								</div>
							)
						} ) }
					</div>
				)
			break

			case 'style-v3':
				output = (
					<div className={ classnames( [
						'products',
						'bookwormgb-products-placeholder-block',
						'row',
						'no-gutters',
						'row-cols-2',
						`row-cols-md-${mdColumns}`,
						`row-cols-lg-${lgColumns}`,
						`row-cols-xl-${xlColumns}`,
						`row-cols-wd-${columns}`,
					], {} ) }>
						{ range( 1, ( placeholder > 0 ? placeholder : limit ) + 1 ).map( i => {
							return(
								<div className={ classnames( [ 'col bookwormgb-products-placeholder' ], { [ `${ responsiveLimitClasses }` ] : i > responsiveLimit, 'mb-2' : i <= marginBottomCount } ) } key={ `product-${i}` }>
									<div className="product__space mx-1 h-100">
										<div className="product__inner overflow-hidden p-3 p-md-4 bg-white h-100">
											<div className="d-block position-relative">
												{ showImage &&
													<div className="progress bg-light mb-2" style={ { height:'200px' } }></div>
												}
												{ showProductFormat &&
													<div className="badge badge-shadow w-50">
														<div className="progress bg-light"></div>
													</div>
												}
												{ showProductTitle &&
													<div className="badge badge-shadow w-80">
														<div className="progress bg-light"></div>
													</div>
												}
												{ showProductAuthor &&
													<div className="badge badge-shadow w-50 d-block">
														<div className="progress bg-light"></div>
													</div>
												}
												{ showProductPrice &&
													<div className="badge badge-shadow w-50">
														<div className="progress bg-light"></div>
													</div>
												}
											</div>
										</div>
									</div>
								</div>
							)
						} ) }
					</div>
				)
			break
		}

		return output
	}
}

export default ProductsPlaceholder